export default {
    navigationBarTitleText: "",
    navigationBarBackgroundColor: "#DF773C",
};
